module.exports = __webpack_public_path__ + "img/52.1db59489.png";